(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["utils/mall-link-redirect"] = factory();
	else
		root["utils/mall-link-redirect"] = factory();
})(globalThis, () => {
return 